module.exports = __webpack_public_path__ + "img/Saint-Kitts-&-Nevis.72ea2355.png";